require( './bootstrap' );

// faq
const faq_container = document.querySelector('.faq-container');
if (faq_container) {
  faq_container.addEventListener('click', function (e) {
    const items = document.querySelectorAll('.faq-container-content')
    const target = e.target
    Array.from(items).forEach(item => {
      if (item !== target) {
        item.classList.remove('show')
      }
    })
    target.classList.toggle('show')
  })
}

$(document).ready(function () {
  // chacked android user and show btn download
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }
  var download = $("#download-mob");
  close = document.querySelector("#closed");
  var showBannerVal = localStorage.getItem("show-banner");
  if (getMobileOperatingSystem() === "Android" && !showBannerVal) {
    console.log("android");
    download.css({ display: "block" });
    $(document).ready(function () {
      var showBannerBtn = $("#closed");
      showBannerBtn.on("click", hideAppBanner);

      if (!showBannerVal) {
        document.getElementsByTagName("body")[0].classList.add("show-banner");
      }
    });

    function hideAppBanner() {
      localStorage.setItem("show-banner", "1");
      document.getElementsByTagName("body")[0].classList.remove("show-banner");
    }
  }
});

$('.burger').on('click', function () {
  $('.menu-top-container').slideToggle();
});

$(window).resize(function () {
  $('.menu-top-container').removeAttr('style');
});

$(document).ready(function(){
  if (navigator.appVersion.indexOf("And")!==-1 || navigator.appVersion.indexOf("Mac")!==-1) {
    $('#desc').css('display','none');
  }
});

document.addEventListener(
    'DOMContentLoaded',
    function () {
      let myLazyLoad = new LazyLoad( {
        elements_selector: ".lazy-load"
      } );
    }
);
// adaptive table class
function coverTable() {
  let table = document.querySelectorAll('table');
  for (let i = table.length - 1; i >= 0; i--) {
    let cover = document.createElement('div');
    cover.classList.add('cover-table');
    table[i].parentNode.insertBefore(cover, table[i]);
    cover.appendChild(table[i]);
  }
}

coverTable();

// to top
function scrollTo(to, duration = 700) {
  const element = document.scrollingElement || document.documentElement,
      start = element.scrollTop,
      change = to - start,
      startDate = +new Date(),
      // t = current time
      // b = start value
      // c = change in value
      // d = duration
      easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      },
      animateScroll = function () {
        const currentDate = +new Date();
        const currentTime = currentDate - startDate;
        element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
        if (currentTime < duration) {
          requestAnimationFrame(animateScroll);
        } else {
          element.scrollTop = to;
        }
      };
  animateScroll();
}

document.addEventListener('DOMContentLoaded', function () {
  let btn = document.querySelector('#toTop');
  if (btn) {
    window.addEventListener('scroll', function () {
      // show if > 599px
      if (pageYOffset > 100) {
        btn.classList.add('show');
        // remove
      } else {
        btn.classList.remove('show');
      }
    });

    // to top on click
    btn.onclick = function (click) {
      click.preventDefault();
      scrollTo(0, 400);
    }
  }
});



